const HERO_DOCUMENT_TYPE_LABELS: Record<string, string> = {
  offer: "Angebot",
  invoice: "Rechnung",
  angebot: "Angebot",
  rechnung: "Rechnung",
  offer_draft: "Angebotsentwurf",
  invoice_draft: "Rechnungsentwurf",
};

function normalizeHeroDocumentTypeKey(value: string): string {
  return value.trim().toLowerCase().replace(/[\s-]+/g, "_");
}

/** Hero liefert Dokumenttypen oft auf Englisch (z. B. „offer“) — für die UI ins Deutsche. */
export function translateHeroDocumentType(value: string | null | undefined): string {
  const raw = String(value ?? "").trim();
  if (!raw) return "—";
  return HERO_DOCUMENT_TYPE_LABELS[normalizeHeroDocumentTypeKey(raw)] ?? raw;
}
